export default __webpack_public_path__ + "static/media/heroplus-bg2-16fe6c4d3f4765bb995266f5ef96b136.png";